import {
  CircularProgress,
  LinearProgress,
  TextField,
  Typography,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: '28px',
  fontWeight: '600',
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flex: '1',
  '& span': { fontSize: '26px', color: theme.palette.secondary.main },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  '& span': { color: theme.palette.secondary.main },
}));

export const DialogTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '24px',
  fontWeight: '600',
  margin: '4px 0 20px',
  '& span': { color: theme.palette.secondary.main },
}));

export const WhiteCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const ColoredCircularProgress = styled(CircularProgress)(
  ({ theme }) => ({
    color: theme.palette.secondary.main,
  })
);

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  ' &.MuiLinearProgress-colorPrimary': {
    backgroundColor: '#EDEDED',
  },
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const textFieldDefaultStyle = {
  width: '100%',
  '& .MuiInputBase-root': { borderRadius: '16px' },
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    '&.Mui-focused fieldset': {
      borderColor: '#595959',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#595959',
  },
  '& .MuiFormLabel-root.Mui-error': {
    color: '#595959 !important',
  },
  '& .MuiInputBase-inputMultiline': {
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'secondary.main',
      borderRadius: 10,
      '&:hover': {
        backgroundColor: 'secondary.dark',
        cursor: 'default',
      },
    },
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
  },
};

export const StyledTextField = styled(TextField)(() => textFieldDefaultStyle);

export const menuItemDefaultStyle = {
  '&:first-of-type': {
    color: '#7c7c7c',
    '&.Mui-selected': { backgroundColor: '#EDEDED' },
    '&:hover': {
      backgroundColor: '#EDEDED',
      cursor: 'auto',
    },
  },
  '&:hover': {
    backgroundColor: '#EDEDED',
  },
  '&.Mui-selected': {
    backgroundColor: alpha('#595959', 0.3),
    '&:hover': {
      backgroundColor: alpha('#595959', 0.3),
    },
  },
};

export const InputTitle = styled(Typography)(() => ({
  paddingBottom: '4px',
  fontSize: '14px',
}));

export const SmallStyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '18px',
  borderBottom: '1px solid #8B8C8E',
  inlineSize: 'fit-content',
  minWidth: '100px',
  paddingLeft: '8px',
  minHeight: '28px',
  textAlign: 'justify',
}));

export const AlertTypography = styled(Typography)(() => ({
  color: '#595959',
  textAlign: 'center',
}));
